import { render, staticRenderFns } from "./AddUserToBlocklistDialog.vue?vue&type=template&id=fad2e20c"
import script from "./AddUserToBlocklistDialog.vue?vue&type=script&lang=js"
export * from "./AddUserToBlocklistDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports